const MARKERS = [
  { id: "maricopa", name: "Phoenix Metro", x: 47.5, y: 62.3, home: true },
  { id: "pima", name: "Tucson", x: 66, y: 83.8, home: false },
  { id: "pinal", name: "Casa Grande", x: 52.5, y: 72.3, home: false },
  { id: "yavapai", name: "Prescott", x: 40.2, y: 43, home: false },
  { id: "coconino", name: "Flagstaff", x: 54.3, y: 31.6, home: false },
  { id: "statewide", name: "Yuma", x: 3.1, y: 75.7, home: false },
];

export const ArizonaMap = ({ active, setActive }) => (
  <svg
    viewBox="0 0 100 105"
    className="w-full max-w-sm mx-auto"
    role="img"
    aria-label="Stylized map of Arizona showing Desert Valley Freight coverage markers"
    data-testid="arizona-map"
  >
    <path
      d="M13 1 L99 1 L99 100 L64 92 L1 76 L4.5 40 L4 18 Z"
      fill="#2E211A"
      stroke="#C85A32"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
    {MARKERS.map((m) => {
      const isActive = active === m.id;
      return (
        <g
          key={m.id}
          data-testid={`map-marker-${m.id}`}
          onMouseEnter={() => setActive(m.id)}
          onMouseLeave={() => setActive(null)}
          className="cursor-pointer"
        >
          <circle cx={m.x} cy={m.y} r="4.5" fill="transparent" />
          {m.home && (
            <circle
              cx={m.x}
              cy={m.y}
              r="2.2"
              fill="none"
              stroke="#E89D4B"
              strokeWidth="0.4"
              className="animate-ping"
              style={{ transformOrigin: `${m.x}px ${m.y}px` }}
            />
          )}
          <circle
            cx={m.x}
            cy={m.y}
            r={isActive ? 2.3 : 1.5}
            fill={isActive ? "#E89D4B" : "#C85A32"}
            className="transition-[r,fill] duration-300"
          />
          <text
            x={m.x + 3}
            y={m.y + 1.1}
            fontSize="3.1"
            fill={isActive ? "#E89D4B" : "#E6DACB"}
            opacity={isActive || m.home ? 1 : 0.5}
            className="font-mono uppercase transition-opacity duration-300"
            style={{ letterSpacing: "0.04em" }}
          >
            {m.name}
          </text>
        </g>
      );
    })}
  </svg>
);
